export default 
`Alexs hobbies:
- playing instruments,
- music production,
- inventing small robots,
- drawing & art,
- chess`